import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';

// init Swiper:
const swiper = new Swiper('.block-slider', {
    modules: [ Autoplay ],
    loop: true,
    speed: 20000, 
    allowTouchMove: false,  
    autoplay: {
        delay: 0,
        pauseOnMouseEnter: false,        // added
        disableOnInteraction: false,    // added
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 1,
            spaceBetween: 50,
        },

        // when window width is >= 600px
        600: {
            slidesPerView: 'auto',
            spaceBetween: 100,
        },

        // when window width is >= 1200px
        1200: {
            slidesPerView: 'auto', 
            spaceBetween: 200,
        }
    }
})